<span *ngIf="!!componentsFiles">
  <h3>Dateien:</h3>

  <clr-datagrid [clrDgLoading]="loading" *transloco="let t; prefix: 'pages.project'">
    <clr-dg-column [clrDgField]="'description'" [clrDgSortOrder]="descSort">{{ t('fileDescription') }}</clr-dg-column>
    <clr-dg-column [clrDgField]="'document_type'">{{ t('documentType') }}</clr-dg-column>
    <clr-dg-column [clrDgField]="'fileName'">Dateiname (im Original)</clr-dg-column>
    <clr-dg-column [clrDgField]="'time'">Hochgeladen am</clr-dg-column>
    <clr-dg-column></clr-dg-column>
    <clr-dg-placeholder>Keine Dateien zu ({{ componentID }}) vorhanden!</clr-dg-placeholder>
    <clr-dg-row *clrDgItems="let componentFile of componentsFiles">
      <clr-dg-action-overflow>
        <button class="action-item" *ngIf="componentFile.fileType === 'application/pdf'" (click)="showModal(componentFile.id, 'lg', componentFile.description + ' (' + componentFile.fileName + ')')">Show PDF</button>
        <button class="action-item" (click)="loadFile(componentFile.id, componentFile.fileName)">Download</button>
      </clr-dg-action-overflow>
      <clr-dg-cell>{{ componentFile.description }}</clr-dg-cell>
      <clr-dg-cell>{{ t( 'docTypes' + '.' + componentFile.document_type.toString() ) }}</clr-dg-cell>
      <clr-dg-cell>{{ componentFile.fileName }}</clr-dg-cell>
      <clr-dg-cell>{{ componentFile.time | date: 'dd.MM.yyyy' }}</clr-dg-cell>
      <clr-dg-cell>
        <button class="btn btn-danger btn-sm btn-icon" (click)="deleteFile(componentFile.id, componentFile.fileName)"><cds-icon shape="trash"></cds-icon></button>
      </clr-dg-cell>
    </clr-dg-row>
    <clr-dg-footer>
      <clr-dg-pagination #pagination [clrDgPageSize]="25">
        <clr-dg-page-size [clrPageSizeOptions]="[10,25,50,100]">Dateien pro Seite</clr-dg-page-size>
        {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
        von {{ componentsFiles.length }} Datei(en)
      </clr-dg-pagination>
    </clr-dg-footer>
  </clr-datagrid>
  <br />
  <div class="btn-group btn-primary">
    <button *ngIf="!showFileUpload" class="btn btn-primary btn-sm" (click)="showFileUploader('md')">Datei hochladen</button>
    <button class="btn btn-primary btn-sm" (click)="downloadZIP(componentsFiles)" [disabled]="isDownloading">
      Dateipaket (ZIP{{ downloadProgress > 0 ? ' - ' + downloadProgress + '%' : '' }})
    </button>
  </div>
  <br />
  <div *ngIf="showFileUpload">
    <h3>Datei für Komponente hinzufügen</h3>
    <app-upload [companyId]=0 [componentId]="componentID" [projectId]="'0'" [jobId]=0 [subId]=0 [docType]=1 (closeModalEvent)="closeModal($event)"></app-upload>
  </div>
</span>

<clr-modal *ngIf="showPDF" id="pdfViewer" [(clrModalOpen)]="showPDF" [clrModalStaticBackdrop]="false" [clrModalSize]="modalSize">
  <h3 class="modal-title">{{ modalContent }} </h3>
  <div class="modal-body">
    <ngx-extended-pdf-viewer [src]="modalUrl" useBrowserLocale="true" height="85vh" [textLayer]="true"></ngx-extended-pdf-viewer>
  </div>
</clr-modal>
